// Finar Ö1 — ProjectsList danışman süzgeci seçenekleri. Kopya TEK kaynak.
export const ASSIGNEE_FILTER_COPY = {
  inactiveSuffix: " (pasif)",
} as const;

export interface AssigneeOptionSource {
  id: string;
  fullName: string;
  /** Eski sunucu yanıtında alan yoksa aktif sayılır. */
  isActive?: boolean;
}

export function buildAssigneeOptions(
  assignees: readonly AssigneeOptionSource[],
): { value: string; label: string }[] {
  return assignees.map((a) => ({
    value: a.id,
    label:
      a.isActive === false ? `${a.fullName}${ASSIGNEE_FILTER_COPY.inactiveSuffix}` : a.fullName,
  }));
}
